import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-search',
  templateUrl: './page-search.component.html',
  styleUrls: ['./page-search.component.sass']
})
export class PageSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
